/* SZT Automotive — countdown, vehicle picker, fit badges, mega menu, rails. */
(function () {
  'use strict';
  var LS_KEY = 'szt_vehicle';

  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      if (val === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, val);
    } catch (e) { /* private mode */ }
    return null;
  }

  /* ---------- countdown ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  function initClocks() {
    var nodes = document.querySelectorAll('[data-szt-clock]');
    if (!nodes.length) return;
    function tick() {
      nodes.forEach(function (el) {
        var end = Date.parse(el.getAttribute('data-szt-clock'));
        if (isNaN(end)) { el.textContent = ''; return; }
        var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (left === 0 && el.getAttribute('data-szt-hide-over') === 'true') {
          var bar = el.closest('.szt-flash');
          if (bar) bar.hidden = true;
          return;
        }
        var d = Math.floor(left / 86400);
        var h = Math.floor((left % 86400) / 3600);
        var m = Math.floor((left % 3600) / 60);
        var s = left % 60;
        el.innerHTML = (d > 0 ? '<span>' + pad(d) + 'd</span>' : '') +
          '<span>' + pad(h) + '</span><span>' + pad(m) + '</span><span>' + pad(s) + '</span>';
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- vehicle data ---------- */
  function vehicles() {
    var el = document.getElementById('szt-vehicle-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  /* ---------- picker cascade ---------- */
  function initPickers() {
    document.querySelectorAll('[data-szt-picker]').forEach(function (form) {
      var data = vehicles();
      var typeSel = form.querySelector('[data-szt-type]');
      var makeSel = form.querySelector('[data-szt-make]');
      var modelSel = form.querySelector('[data-szt-model]');
      if (!typeSel || !makeSel || !modelSel) return;

      function fill(sel, values, placeholder) {
        sel.innerHTML = '<option value="">' + placeholder + '</option>' +
          values.map(function (v) { return '<option value="' + v.value + '">' + v.label + '</option>'; }).join('');
        sel.disabled = values.length === 0;
      }
      function uniq(list) { return list.filter(function (v, i, a) { return a.indexOf(v) === i; }); }

      function onType() {
        var t = typeSel.value;
        var makes = uniq(data.filter(function (v) { return !t || v.type === t; }).map(function (v) { return v.make; })).sort();
        fill(makeSel, makes.map(function (m) { return { value: m, label: m }; }), makeSel.dataset.placeholder || 'Make');
        fill(modelSel, [], modelSel.dataset.placeholder || 'Model');
      }
      function onMake() {
        var t = typeSel.value, mk = makeSel.value;
        var models = data.filter(function (v) { return (!t || v.type === t) && v.make === mk; });
        fill(modelSel, models.map(function (v) { return { value: v.handle, label: v.model }; }), modelSel.dataset.placeholder || 'Model');
      }
      typeSel.addEventListener('change', onType);
      makeSel.addEventListener('change', onMake);
      onType();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var handle = modelSel.value;
        if (!handle) return;
        var v = data.filter(function (x) { return x.handle === handle; })[0];
        if (!v) return;
        store(LS_KEY, handle);
        if (v.url) window.location.href = v.url;
      });

      var clear = form.querySelector('[data-szt-clear]');
      if (clear) clear.addEventListener('click', function (e) {
        e.preventDefault(); store(LS_KEY, null); window.location.reload();
      });
    });
  }

  /* ---------- saved-vehicle labels and fit badges ---------- */
  function applyFit() {
    var handle = store(LS_KEY);
    var data = vehicles();
    var v = handle ? data.filter(function (x) { return x.handle === handle; })[0] : null;

    document.querySelectorAll('[data-szt-saved-label]').forEach(function (el) {
      el.textContent = v ? (v.make + ' ' + v.model) : (el.dataset.sztSavedLabel || '');
      el.closest('[data-szt-saved-wrap]') && (el.closest('[data-szt-saved-wrap]').hidden = !v);
    });
    if (!v) return;

    document.querySelectorAll('[data-fits]').forEach(function (card) {
      var list = (card.getAttribute('data-fits') || '').split(' ').filter(Boolean);
      var universal = card.getAttribute('data-universal') === 'true';
      if (list.indexOf(handle) === -1 && !universal) return;
      var fitLine = card.querySelector('.szt-fit');
      if (fitLine && list.indexOf(handle) !== -1) {
        fitLine.textContent = fitLine.dataset.confirmed || 'Confirmed fit';
        fitLine.classList.remove('szt-fit--universal');
      }
      var badge = card.querySelector('[data-szt-fit-badge]');
      if (badge && list.indexOf(handle) !== -1) {
        badge.hidden = false;
        badge.textContent = badge.dataset.label || 'Fits yours';
      }
    });

    document.querySelectorAll('[data-szt-fitbox]').forEach(function (box) {
      var list = (box.getAttribute('data-fits') || '').split(' ').filter(Boolean);
      var title = box.querySelector('[data-szt-fitbox-title]');
      if (!title) return;
      if (list.indexOf(handle) !== -1) {
        title.textContent = (title.dataset.matchPrefix || 'Fits your') + ' ' + v.make + ' ' + v.model;
        box.classList.remove('szt-fitbox--neutral');
      }
    });
  }

  /* ---------- mega menu ---------- */
  function initMega() {
    var bar = document.querySelector('[data-szt-mega]');
    if (!bar) return;
    var tops = bar.querySelectorAll('.szt-mega__top[aria-controls]');
    function closeAll(except) {
      tops.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.classList.remove('is-open');
      });
    }
    tops.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        var open = t.getAttribute('aria-expanded') === 'true';
        closeAll(t);
        t.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.classList.toggle('is-open', !open);
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-szt-mega-root]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
  }

  function init() {
    initClocks();
    initPickers();
    initMega();
    applyFit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
